import React from 'react';
import { Section } from './ui/Section';
import { Check, ArrowRight, Flame } from 'lucide-react';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
export default function IncludesSection() {
  const items = ['PDF principal — guía completa del sistema', 'Plantilla: Lista Maestra', 'Plantilla: Semana 12-3-2', 'Plantilla: Lista de compras por bloques', 'Plan de emergencias — 2 cenas sin pensar'];
  const scrollToPricing = () => {
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <Section className="bg-brand-cream-dark" data-id="element-177">
      <div className="flex flex-col lg:grid lg:grid-cols-2 gap-12 items-center" data-id="element-178">
        <div data-id="element-179">
          <h2 className="font-heading text-4xl md:text-5xl text-slate-900 mb-8 uppercase tracking-wide" data-id="element-180">
            ¿Qué incluye <br data-id="element-181" />
            <span className="text-brand-purple" data-id="element-182">CERO DECISIONES</span>?
          </h2>

          <ul className="space-y-4 mb-10" data-id="element-183">
            {items.map((item, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start" data-id="element-184">
                <motion.div initial={{
              scale: 0
            }} whileInView={{
              scale: 1
            }} transition={{
              delay: index * 0.1 + 0.2,
              type: 'spring'
            }} className="bg-brand-purple/15 p-1 rounded-full mr-4 mt-1" data-id="element-185">
                  <Check className="text-brand-purple" size={20} data-id="element-186" />
                </motion.div>
                <span className="text-xl text-slate-700" data-id="element-187">{item}</span>
              </motion.li>)}
          </ul>

          <p className="text-brand-brown italic text-xl mb-8 border-l-4 border-brand-brown pl-4" data-id="element-188">
            Todo diseñado para una cosa: que lo uses, no que «se vea lindo».
          </p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8
        }} className="relative flex justify-center mb-8 lg:hidden" data-id="element-189">
            <img src="https://cdn.magicpatterns.com/uploads/97yFfXtSa3qEUhJ4cYgF3R/banner-25668_(1).png" alt="CERO DECISIONES Bundle" className="relative w-full max-w-sm rounded-lg shadow-2xl animate-float" data-id="element-190" />
          </motion.div>

          <div className="flex flex-col items-start gap-3" data-id="element-191">
            <Button size="lg" pulse={true} className="w-full sm:w-auto" onClick={scrollToPricing} data-id="element-192">
              QUIERO MI SISTEMA AHORA <ArrowRight className="ml-2" size={20} data-id="element-193" />
            </Button>
            <div className="flex flex-col gap-1 ml-1" data-id="element-194">
              <div className="flex items-center gap-1 text-red-600 text-sm font-bold animate-pulse" data-id="element-195">
                <Flame size={14} data-id="element-196" />
                <span data-id="element-197">Últimas copias a este precio</span>
              </div>
              <span className="text-slate-400 text-xs" data-id="element-198">
                ✓ Garantía 7 días — 0 riesgo para ti
              </span>
            </div>
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8
      }} className="relative hidden lg:flex justify-center" data-id="element-199">
          <img src="https://cdn.magicpatterns.com/uploads/97yFfXtSa3qEUhJ4cYgF3R/banner-25668_(1).png" alt="CERO DECISIONES Bundle" className="relative w-full max-w-md rounded-lg shadow-2xl transform hover:scale-105 transition-transform duration-500 animate-float" data-id="element-200" />
        </motion.div>
      </div>
    </Section>;
}